const subscriptionStatus = Object.freeze({
  0: 'SubscriptionStatus_Unsubscribed',
  1: 'SubscriptionStatus_Subscribed',
  2: 'SubscriptionStatus_Undefined'
})

const subscriptionStatusKeys = Object.freeze({
  Unsubscribed: 0,
  Subscribed: 1,
  Undefined: 2
})

export { subscriptionStatus, subscriptionStatusKeys }



// WEBPACK FOOTER //
// ./src/modules/profiles/enum/SubscriptionStatusEnum.js